import "./Landing.css";

function TypewriterLine({ children, animationClass }) {
  return (
    <h1 className="grid mx-auto w-fit font-mono font-bold text-heading">
      <span
        className={`col-start-1 row-start-1 pr-1 overflow-hidden whitespace-nowrap border-r-4 opacity-0 border-r-accent ${animationClass}`}
      >
        {children}
      </span>
      <span
        className="col-start-1 row-start-1 col-end-2 row-end-2 pr-2 invisible whitespace-nowrap pointer-events-none select-none"
        aria-hidden="true"
      >
        {children}
      </span>
    </h1>
  );
}

const Typewriter = () => {
  return (
    <div className="w-full text-xl text-center xr:text-2xl sm:text-4xl md:text-5xl">
      <TypewriterLine animationClass="animate-typing1">
        Hello, world. I&apos;m Ryan!
      </TypewriterLine>
      <TypewriterLine animationClass="animate-typing2">
        I&apos;m a Full Stack &lt;<span className="text-accent">Dev </span>/&gt;
      </TypewriterLine>
    </div>
  );
};

export default Typewriter;
